/**
 * Checks whether the provided value is a currency.
 *
 * @param {string | undefined} currency
 * @returns {boolean}
 */
export function isCurrency(currency) {
  return typeof currency === "string" && currency.length === 3;
}
